import React from 'react';

const Title = (props) => {
  return <h3 className="page-title page-title-template"><div dangerouslySetInnerHTML={{ __html: props.data.title }}></div></h3>;
};

export default Title;
